import { useSelector } from 'react-redux';

const UserDefinedLabels = () => {
  const { adminConfigData } = useSelector((state) => state.user);
  const CertificateNumber = adminConfigData?.attributeNameConfiguration.filter(
    (item) => item.attributeKey === 'certificateNumber',
  );
  const AlternateID1 = adminConfigData?.attributeNameConfiguration.filter(
    (item) => item.attributeKey === 'alternateID1',
  );
  const AlternateID2 = adminConfigData?.attributeNameConfiguration.filter(
    (item) => item.attributeKey === 'alternateID2',
  );
  const defaultMemberID =
    adminConfigData &&
    adminConfigData?.attributeNameConfiguration.filter((item) => item.memberID);

  return {
    CertificateNumberLabel: CertificateNumber[0]?.attributeValue,
    AlternateID1Label: AlternateID1[0]?.attributeValue,
    AlternateID2Label: AlternateID2[0]?.attributeValue,
    DefaultMemberIDKey: defaultMemberID[0]?.attributeKey,
  };
};
export default UserDefinedLabels;
